import { render, staticRenderFns } from "./roomBuying.vue?vue&type=template&id=52827ad3&scoped=true&"
import script from "./roomBuying.vue?vue&type=script&lang=js&"
export * from "./roomBuying.vue?vue&type=script&lang=js&"
import style0 from "./roomBuying.vue?vue&type=style&index=0&id=52827ad3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52827ad3",
  null
  
)

export default component.exports